import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { parseStdNumber } from '@products/utils/mappers/mapper.utils';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { FundId, ShareClassCode } from '@types';
import { IndexesAllocation } from '../../us-index-allocations/us-index-allocations.config';
import { IndexAssetAllocationDTO } from '../dto/indexes.dto.types';
import { IndexAssetAllocation } from '../model/indexes';

export class IndexAssetAllocationsMapper extends Mapper<
  IndexAssetAllocation[]
> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    indexAssetAllocationsDTO: IndexAssetAllocationDTO[]
  ): IndexAssetAllocation[] {
    const indexAssetAllocations: IndexAssetAllocation[] = [];

    indexAssetAllocationsDTO.forEach((indexAssetAllocationDTO) => {
      const indexAssetAllocation: IndexAssetAllocation = this.createMapper(
        IndexAssetAllocationMapper
      ).toDomain(indexAssetAllocationDTO);

      if (indexAssetAllocation) {
        indexAssetAllocations.push(indexAssetAllocation);
      }
    });

    return indexAssetAllocations;
  }
}

export class IndexAssetAllocationMapper extends Mapper<IndexAssetAllocation> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    indexAssetAllocationDTO: IndexAssetAllocationDTO
  ): IndexAssetAllocation {
    return {
      fundId: indexAssetAllocationDTO.fundid as FundId,
      shareClassCode: indexAssetAllocationDTO.shareclasscode as ShareClassCode,
      categoryNameStd: indexAssetAllocationDTO.categorynamestd as IndexesAllocation,
      categoryDescription: indexAssetAllocationDTO.categorydescription,
      breakdownPercentageStd: parseStdNumber(
        indexAssetAllocationDTO.brkdwnpercentagestd
      ),
      breakdownPercentage: indexAssetAllocationDTO.brkdwnpercentage,
      asOfDateStd: indexAssetAllocationDTO.asofdatestd,
      asOfDate: indexAssetAllocationDTO.asofdate,
    };
  }
}
